import { gql } from '@apollo/client';

export const VERIFY_DRIVER_LICENCE_DVLA = gql`
  query driverVerifyLicenseWithDvla(
    $driverId: String!
    $licenseNumber: String!
    $insuranceNumber: String!
    $postCode: String!
  ) {
    driverVerifyLicenseWithDvla(
      driverId: $driverId
      licenseNumber: $licenseNumber
      insuranceNumber: $insuranceNumber
      postCode: $postCode
    ) {
      success
      message
    }
  }
`;